import { Link } from 'react-router-dom';
import type { Project } from '../../types/project';

interface ProjectCardProps {
  project: Project;
}

export default function ProjectCard({ project }: ProjectCardProps) {
  return (
    <Link
      to={`/projects/${project.slug}`}
      className="card-neubrutal bg-white p-6 rounded-lg block"
    >
      {project.coverImage && (
        <div className="aspect-video mb-4 bg-gradient-to-br from-primary/20 to-cta/20 border-2 border-black rounded-lg flex items-center justify-center overflow-hidden">
          <span className="text-6xl">🚀</span>
        </div>
      )}
      <h3 className="text-2xl font-heading font-bold mb-2">
        {project.title}
      </h3>
      <p className="text-gray-600 mb-4 line-clamp-3">
        {project.description}
      </p>
      <div className="flex flex-wrap gap-2 mb-4">
        {project.techStack.map((tech) => (
          <span
            key={tech}
            className="text-xs px-2 py-1 border-2 border-black bg-secondary rounded-full"
          >
            {tech}
          </span>
        ))}
      </div>
      <div className="flex gap-3">
        {project.liveUrl && (
          <span className="text-cta font-medium text-sm">
            查看演示 →
          </span>
        )}
        {project.githubUrl && (
          <span className="text-gray-600 font-medium text-sm">
            GitHub
          </span>
        )}
      </div>
    </Link>
  );
}
